'use client';

import ARGameContainer from './ARGameContainer';
import { configureReducer } from '@/redux';
import { Provider } from 'react-redux';

type ARGameViewProps = {
  gameId: string;
  customDomain?: string;
};

const store = configureReducer();

const ARGameView = ({ gameId, customDomain }: ARGameViewProps) => {
  return (
    <Provider store={store}>
      <ARGameContainer gameId={gameId} customDomain={customDomain} />
    </Provider>
  );
};

export default ARGameView;
